import LS_API from '../api/axios';

class FeatureService {
    getAvailableFeatures = async () => {
        try {
            const response = await LS_API.get('/api/report/available-features');
            // Backend returns the raw Power BI JSON as a String body — parse
            // defensively in case Content-Type wasn't set to application/json
            // and axios left it as a raw string instead of auto-parsing it.
            const data = response.data;
            return typeof data === 'string' ? JSON.parse(data) : data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    };
}

export default new FeatureService();